import React from "react";
import { Link } from "react-router-dom";
import "../css/UpcomingEvents.css";

const EVENTS = [
  {
    date: "15",
    month: "July 2026",
    title: "Annual Sports Day",
    image:
      "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=1200",

    desc: "Students participate in various sports activities promoting teamwork, fitness, leadership and sportsmanship.",
  },

  {
    date: "22",
    month: "August 2026",
    title: "Science Exhibition",
    image:
      "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=1200",

    desc: "A platform where students showcase creativity, innovation and scientific projects.",
  },

  {
    date: "10",
    month: "September 2026",
    title: "Parent Teacher Meeting",
    image:
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1200",

    desc: "An interactive meeting between parents and teachers to discuss student progress.",
  },

  {
    date: "05",
    month: "October 2026",
    title: "Cultural Festival",
    image:
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200",

    desc: "Students celebrate culture, creativity and talents through performances and activities.",
  },
];

const UpcomingEvents = () => {
  return (
    <section className="events-page">
      <div className="events-container">
        <div className="events-header">
          <span>Sahara Public Secondary School • Nepal</span>

          <h1>Upcoming Events</h1>

          <p>
            Discover school activities, celebrations and learning experiences
            that make campus life exciting and meaningful.
          </p>
        </div>

        <div className="events-grid">
          {EVENTS.map((event, index) => (
            <div className="event-card" key={index}>
              <div className="event-image">
                <img src={event.image} alt={event.title} />

                <div className="event-date">
                  <strong>{event.date}</strong>

                  <span>{event.month}</span>
                </div>
              </div>

              <div className="event-content">
                <h2>{event.title}</h2>

                <p>{event.desc}</p>

                <Link to="/contact">Read More →</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
